"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.PriceTransparencyWidget = void 0;
var React = require("react");
var PriceTransparencyChart_1 = require("./PriceTransparencyChart");
var PriceTransparencyCarousel_1 = require("./PriceTransparencyCarousel");
var reactstrap_1 = require("reactstrap");
var PriceTransparencyWidget = /** @class */ (function (_super) {
    __extends(PriceTransparencyWidget, _super);
    function PriceTransparencyWidget(props) {
        var _this = _super.call(this, props) || this;
        _this.minValue = 10;
        _this.maxValue = 50;
        _this.prepareData = function () {
            var addressValue = _this.props.vehicles
                .map(function (vehicle) { return (vehicle.mlOutputData && vehicle.mlOutputData.l1_Location) ? vehicle.mlOutputData.l1_Location : 0; })
                .reduce(function (prev, current) { return prev + current; }, 0);
            var coverValue = _this.props.vehicles
                .map(function (vehicle) { return (vehicle.mlOutputData && vehicle.mlOutputData.l1_Cover) ? vehicle.mlOutputData.l1_Cover : 0; })
                .reduce(function (prev, current) { return prev + current; }, 0);
            var driverValue = _this.props.vehicles
                .map(function (vehicle) { return (vehicle.mlOutputData && vehicle.mlOutputData.l1_Who) ? vehicle.mlOutputData.l1_Who : 0; })
                .reduce(function (prev, current) { return prev + current; }, 0);
            var carValue = _this.props.vehicles
                .map(function (vehicle) { return (vehicle.mlOutputData && vehicle.mlOutputData.l1_Vehicle) ? vehicle.mlOutputData.l1_Vehicle : 0; })
                .reduce(function (prev, current) { return prev + current; }, 0);
            var textForAddress = (React.createElement(React.Fragment, null,
                "We\u2019ll take into account the local population, levels of vehicle crime and where you park your car.",
                React.createElement("b", null,
                    " Your address ",
                    addressValue > 0 ? "increased" : "decreased",
                    " your price.")));
            var textForCover = (React.createElement(React.Fragment, null,
                "Your cover, excess and any optional extras you have will affect you premium.",
                React.createElement("b", null,
                    " Your choice of cover ",
                    coverValue > 0 ? "increased" : "decreased",
                    " your price.")));
            var textForDriver = (React.createElement(React.Fragment, null,
                "Your age, claims history, and driving experience affect how much you pay.",
                React.createElement("b", null,
                    " Driver details ",
                    driverValue > 0 ? "increased" : "decreased",
                    " your price.")));
            var textForCar = (React.createElement(React.Fragment, null,
                "The model, engine size and cost of your car will affect your premium.",
                React.createElement("b", null,
                    " Your car ",
                    carValue > 0 ? "increased" : "decreased",
                    " your price.")));
            return [
                { name: "Address", value: _this.setMinMaxValue(addressValue), description: textForAddress },
                { name: "Cover", value: _this.setMinMaxValue(coverValue), description: textForCover },
                { name: _this.props.isMultipleDrivers ? "Drivers" : "Driver", value: _this.setMinMaxValue(driverValue), description: textForDriver },
                { name: _this.props.vehicles.length > 1 ? "Cars" : "Car", value: _this.setMinMaxValue(carValue), description: textForCar }
            ];
        };
        _this.setMinMaxValue = function (value) {
            var minValue = _this.minValue * _this.props.vehicles.length;
            var maxValue = _this.maxValue * _this.props.vehicles.length;
            if (value > 0 && value < minValue) {
                return minValue;
            }
            else if (value < 0 && value > -minValue) {
                return -minValue;
            }
            else if (value > maxValue) {
                return maxValue;
            }
            else if (value < -maxValue) {
                return -maxValue;
            }
            else {
                return value;
            }
        };
        _this.setActiveIndex = function (index) { return _this.setState({ activeIndex: index }); };
        _this.toggle = function () { return _this.setState({ isModalOpen: !_this.state.isModalOpen }); };
        _this.state = {
            activeIndex: 3,
            isModalOpen: false
        };
        return _this;
    }
    PriceTransparencyWidget.prototype.render = function () {
        if (this.props.vehicles && this.props.vehicles.length > 0) {
            var data = this.prepareData();
            if (data.every(function (d) { return d.value === 0; })) {
                return React.createElement(React.Fragment, null);
            }
            else {
                return (React.createElement("div", { className: "price-transparency-widget _panel rounded bg-white-blue m-0 p-0 " + this.props.className },
                    React.createElement("div", { className: "cursor-pointer d-flex p-3", onClick: this.toggle },
                        React.createElement("img", { className: "mr-3", src: "/img/Flow-info.svg", alt: "Price transparency info" }),
                        React.createElement("div", { className: "line-height-15" },
                            React.createElement("span", { className: "font-weight-bold font-family-display" }, "How do we calculate your price? "),
                            React.createElement("span", { className: "text-decoration-underline text-blue-1 font-weight-extra-light" }, "Please check the factors that influence your price"))),
                    React.createElement(reactstrap_1.Modal, { className: "price-transparency-modal", isOpen: this.state.isModalOpen, toggle: this.toggle, centered: true, fade: false, scrollable: true },
                        React.createElement(reactstrap_1.ModalHeader, { toggle: this.toggle, close: React.createElement("button", { className: "btn-close", onClick: this.toggle }) },
                            React.createElement("div", { className: "pt-4 text-center text-blue-2 font-weight-bold font-family-display fs-18" }, "Factors affecting your price")),
                        React.createElement(reactstrap_1.ModalBody, { className: "p-0" },
                            React.createElement(PriceTransparencyChart_1.PriceTransparencyChart, { className: "mt-2 mx-2", data: data, activeIndex: this.state.activeIndex, setActiveIndex: this.setActiveIndex }),
                            React.createElement(PriceTransparencyCarousel_1.PriceTransparencyCarousel, { className: "mt-5 mb-5", data: data, activeIndex: this.state.activeIndex, setActiveIndex: this.setActiveIndex })))));
            }
        }
        else {
            return React.createElement(React.Fragment, null);
        }
    };
    return PriceTransparencyWidget;
}(React.Component));
exports.PriceTransparencyWidget = PriceTransparencyWidget;
//# sourceMappingURL=PriceTransparencyWidget.js.map


//////////////////
// WEBPACK FOOTER
// ../falcon-plugins/plugin-falcon-journey/dist/widgets/annual/motor/priceTransparency/PriceTransparencyWidget.js
// module id = 1081
// module chunks = 0